import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { isCmUploadableFile } from "./hixUploadResolver";

export function useMenuItem_HixUpload(selectedItems: any[], setIsHixPanelOpen?: (isOpen: boolean) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const enableHix = useSelector((state: RootState) => state.tenantInfo?.enableHix);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.at(-1));

  const menuItem_HixUpload = React.useMemo(() => {
    const uploadableCount = (selectedItems ?? []).filter(isCmUploadableFile).length;
    if (enableHix && uploadableCount > 0 && currentDirectory?.type !== ComponentTypes.SharePointList) {
      return {
        key: "hixUpload",
        iconProps: {},
        onRenderIcon: () => <img src={`${process.env.baseUri}/assets/hix_logo.png`} alt="HIX" className={menuItemIconStyles} style={{ width: 20, height: "auto" }} />,
        text: languageStrings.UploadToHix,
        onClick: () => setIsHixPanelOpen?.(true),
      } as IContextualMenuItem;
    }
    return null;
  }, [enableHix, selectedItems, currentDirectory, languageStrings, setIsHixPanelOpen]);

  return {
    menuItem_HixUpload
  };
}
